import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import OutlinedInput from '@mui/material/OutlinedInput';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { SelectChangeEvent } from '@mui/material';
import { useEffect, useState } from 'react';
import Pagin, { PaginationType } from 'src/components/common/Pagin';
import { postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import { getDetailPagin } from 'src/common/helper';
import Rows from './Rows';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import BtnGradient from 'src/components/common/button/BtnGradient';
import { useNavigate } from 'react-router-dom';

type FilterType = {
  keyword: string;
  status: string;
};

const statuses = [
  {
    name: '有効',
    value: '1',
  },
  {
    name: '無効',
    value: '0',
  },
];

const Index = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<any>([]);
  const [pagination, setPagination] = useState<PaginationType>();

  const [searchs, setSearchs] = useState<FilterType>({
    keyword: '',
    status: '1',
  });

  const getUsers = async (page: number) => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error('Failed to get access token');
      }

      postAPI(`/auth/user-list?token=${token}`, {
        keyword: searchs.keyword,
        status: searchs.status,
        page: page,
        pagesize: 10,
      })
        .then((res: any) => {
          if (res.code === 200 && res.data) {
            setData(res.data.items);
            setPagination(res.data.pagination);
          }
        })
        .finally(() => {});
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  };

  useEffect(() => {
    getUsers(1);
    // eslint-disable-next-line
  }, []);

  const handlePageChange = (eventL: any, value: number) => {
    getUsers(value);
  };

  const handleCreateNew = () => {
    navigate('/user/edit');
  };

  const handleSearch = () => {
    getUsers(1);
  };

  const handleInputSearch = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    setSearchs({
      ...searchs,
      [name]: value,
    });
  };

  const handleStatusChange = (event: SelectChangeEvent<string>) => {
    const { name, value } = event.target;
    setSearchs({
      ...searchs,
      [name]: value,
    });
  };

  return (
    <Stack width={'100%'}>
      <Stack
        direction={'row'}
        justifyContent={'space-between'}
        spacing={'8px'}
        mb={'30px'}
      >
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          spacing={'8px'}
        >
          <OutlinedInput
            placeholder={'タスク名'}
            sx={{
              fontSize: '14px',
              height: '32px',
              my: '8px',
              '& .MuiOutlinedInput-notchedOutline': { borderColor: '#BDBDBD' },
              '& .MuiInputBase-input': { padding: '5px 14px' },
              '& input::placeholder': {
                fontSize: '14px',
                fontWeight: 500,
                color: '#CCD1D9',
                opacity: 1,
              },
              backgroundColor: 'primary.light',
              width: '200px',
              mr: '8px',
            }}
            inputProps={{
              sx: {
                backgroundColor: 'primary.light',
              },
            }}
            name='keyword'
            value={searchs.keyword}
            onChange={(event) => handleInputSearch(event)}
          />
          <Select
            className='select-status'
            value={searchs.status}
            name='status'
            onChange={(event) => handleStatusChange(event)}
            sx={{
              '& .MuiSelect-select.MuiSelect-outlined': {
                py: '5px',
              },
              width: '200px',
            }}
          >
            {statuses.map((status: any, index) => {
              return (
                <MenuItem key={index} value={status.value}>
                  {status.name}
                </MenuItem>
              );
            })}
          </Select>
          <BtnGradient text='検索' handleButtonClick={handleSearch} />
        </Stack>
        <BtnOutlineGradient
          text='新規作成'
          handleButtonClick={handleCreateNew}
          width='120px'
          srcStartIcon='/images/icons/ic-plus-gradient.svg'
        />
      </Stack>
      <TableContainer component={Paper}>
        <Table
          sx={{
            minWidth: 650,
            '& .MuiTableCell-root.MuiTableCell-head': {
              borderBottom: '1px solid #F3F3F3',
              fontWeight: 700,
              p: '6px 16px',
              fontSize: '14px',
            },
            '& .MuiTableCell-root.MuiTableCell-body': {
              color: 'primary.dark',
              fontSize: '14px',
              py: '10px',
            },
          }}
          aria-label='simple table'
        >
          <TableHead>
            <TableRow>
              <TableCell>氏名</TableCell>
              <TableCell>ログイン名</TableCell>
              <TableCell>職種</TableCell>
              <TableCell>最終ログイン</TableCell>
              <TableCell>備考</TableCell>
              <TableCell>表示順位</TableCell>
              <TableCell>ステータス</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 &&
              data.map((item: any, index: number) => (
                <Rows item={item} key={index} />
              ))}
            {data.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={7}
                  sx={{ textAlign: 'center', verticalAlign: 'center' }}
                >
                  データがありません
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {data.length > 0 && pagination && (
        <Box display={'flex'} justifyContent={'right'} mt={'10px'}>
          <Typography
            component='label'
            sx={{
              color: '#AAB2BD',
              fontWeight: '400',
              fontSize: '10px',
              lineHeight: '12px',
            }}
          >
            {getDetailPagin(pagination)}
          </Typography>
        </Box>
      )}
      {data.length > 0 && pagination && pagination.page && (
        <Pagin handlePageChange={handlePageChange} pagination={pagination} />
      )}
    </Stack>
  );
};

export default Index;
